import silverCircle from '../../photos/border/SilverCircle.png'
import goldCircle from '../../photos/border/GoldCircle.png'
import roseGoldCircle from '../../photos/border/RoseGoldCircle.png'
import silverDiamond from '../../photos/border/SilverDiamond.png'
import goldDiamond from '../../photos/border/GoldDiamond.png'
import roseGoldDiamond from '../../photos/border/RoseGoldDiamond.png'
import silverBotanical from '../../photos/border/SilverBotanical.png'
import goldBotanical from '../../photos/border/GoldBotanical.png'
import roseGoldBotanical from '../../photos/border/RoseGoldBotanical.png'
import placeHolderImage from '../../photos/planner/empty/empty.png'

const BorderRenderer = ({ borderSelected, colorSelected }) => {

    const borders = {
        Botanical: [
            { "Silver": silverBotanical },
            { "Gold": goldBotanical },
            { "Rose Gold": roseGoldBotanical }
        ],
        Diamond: [
            { "Silver": silverDiamond },
            { "Gold": goldDiamond },
            { "Rose Gold": roseGoldDiamond }
        ],
        Circle: [
            { "Silver": silverCircle },
            { "Gold": goldCircle },
            { "Rose Gold": roseGoldCircle }
        ],
    };
    const getImageUrl = (border, color) => {
        const borderArray = borders[border];
        if (!borderArray) return null;
        const borderObj = borderArray.find(item => item[color]);
        return borderObj ? borderObj[color] : null;
    };

    const calendarImageUrl = getImageUrl(borderSelected, colorSelected);


    return (
        <>
            <img alt='' width={150} height={150} src={!calendarImageUrl ? placeHolderImage : calendarImageUrl} style={{ position: 'absolute', zIndex: 1, objectFit: 'cover', maxHeight: '150px', }} />
        </>)
}
export default BorderRenderer;











